<template>
  <div class="usa-tax">
    <v-radio :disabled="disabled" :val="taxClasses.INDIVIDUAL" name="taxClassification" v-model="localValue">Individual/sole proprietor or single-member LLC</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.C_CORPORATION" v-model="localValue">C Corporation</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.S_CORPORATION" v-model="localValue">S Corporation</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.P_PARTNERSHIP" v-model="localValue">Partnership</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.TRUST_ESTATE" v-model="localValue">Trust/estate</v-radio>
    <v-radio :disabled="disabled" :val="taxClasses.LIMITED" v-model="localValue">Limited liability company</v-radio>
    <transition name="fade">
      <v-autocomplete v-if="localValue === taxClasses.LIMITED" v-bind="llcProps" v-model="llcTaxLocal"></v-autocomplete>
    </transition>
    <v-radio :disabled="disabled" :val="taxClasses.OTHER" v-model="localValue">Other</v-radio>
    <div class="usa-tax__error text-color-error" v-if="error">{{error}}</div>
  </div>
</template>

<script>
import vRadio from '@/ui/controls/vRadio'
import vAutocomplete from '@/ui/controls/Autocomplete'

export default {
  data () {
    return {
      localValue: null,
      llcTaxLocal: null
    }
  },

  components: {
    vRadio,
    vAutocomplete
  },

  computed: {
    taxClasses () {
      return {
        INDIVIDUAL: 'INDIVIDUAL',
        C_CORPORATION: 'C_CORPORATION',
        S_CORPORATION: 'S_CORPORATION',
        P_PARTNERSHIP: 'P_PARTNERSHIP',
        TRUST_ESTATE: 'TRUST_ESTATE',
        //
        LIMITED: 'LIMITED',
        LIMITED_C: 'LIMITED_C',
        LIMITED_S: 'LIMITED_S',
        LIMITED_P: 'LIMITED_P',
        //
        OTHER: 'OTHER'
      }
    },

    llcProps () {
      return {
        placeholder: 'Tax classification',
        items: [
          {
            id: this.taxClasses.LIMITED_C,
            name: 'C=C corporation'
          },
          {
            id: this.taxClasses.LIMITED_S,
            name: 'S=S corporation'
          },
          {
            id: this.taxClasses.LIMITED_P,
            name: 'P=Partnership'
          }
        ],
        itemText: 'name',
        valueField: 'id'
      }
    }
  },

  mounted () {
    if (
      this.value === this.taxClasses.LIMITED_C ||
      this.value === this.taxClasses.LIMITED_S ||
      this.value === this.taxClasses.LIMITED_P
    ) {
      this.localValue = this.taxClasses.LIMITED
      this.llcTaxLocal = this.value
    }
  },

  props: {
    value: {
      type: String,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    error: {
      type: String,
      default: null
    }
  },

  watch: {
    value (val) {
      if (
        val === this.taxClasses.LIMITED_C ||
        val === this.taxClasses.LIMITED_S ||
        val === this.taxClasses.LIMITED_P
      ) {
        this.localValue = this.taxClasses.LIMITED
        this.llcTaxLocal = val
      } else if (val !== this.taxClasses.LIMITED && val !== '') {
        this.localValue = val
      }
    },

    localValue (val) {
      if (
        val !== 'LIMITED'
      ) {
        this.$emit('input', val)
      } else if (val === this.taxClasses.LIMITED) {
        this.$emit('input', '')
      }
    },

    llcTaxLocal (val) {
      this.$emit('input', val)
    }
  }
}
</script>
